module.exports = __webpack_public_path__ + "static/media/check-square.8b47559f.svg";